import React, { Component } from 'react'
import { connect } from 'react-redux';
import { setFilter } from '../../actions/filters'
import ReferenceAutocomplete from '../utilities/ReferenceAutocomplete'
import getParams from '../utilities/getParams'

class ReferenceFilter extends Component {
    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
        this.clearFilter = this.clearFilter.bind(this)
        this.inputRef = React.createRef()
        this.state = {
            search: ""
        }

    }


    componentDidMount() {
        const getRefProps = this.props
        const getRefPreviousValue = this.props.value1


        this.setState({
            search: getRefPreviousValue
        })

    }

    clearFilter() {
        if (this.inputRef.current &&
            this.inputRef.current.wrappedInstance &&
            this.inputRef.current.wrappedInstance.handleClear &&
            typeof this.inputRef.current.wrappedInstance.handleClear === "function") {
            if (this.inputRef.current.wrappedInstance.mainInput && this.inputRef.current.wrappedInstance.mainInput.value) {
                this.inputRef.current.wrappedInstance.handleClear()
            } else {
                if (this.inputRef.current.wrappedInstance.mainInput && this.inputRef.current.wrappedInstance.mainInput.value === "") {
                    let txt = ""

                    let filter = {}
                    filter[this.props.filterName] = {
                        type: "reference",
                        value1: txt,
                        referenceEndpoint: this.props.referenceEndpoint
                    }
                    this.props.dispatch(setFilter(
                        this.props.id,
                        filter
                    ))
                }
            }
        }
        //this.inputRef.wrappedInstance.handleClear()
    }

    handleChange(event) {
        let txt = Number(event.target.value) || ""

        let filter = {}
        filter[this.props.filterName] = {
            type: "reference",
            value1: txt,
            referenceEndpoint: this.props.referenceEndpoint
        }
        this.props.dispatch(setFilter(
            this.props.id,
            filter
        ))
    }

    render() {
        let filterValue = this.state.search //this.props.value1
        let referencedEndpointName = this.props.referenceEndpoint
        return (

            <ReferenceAutocomplete
                location={this.props.location}
                ref={this.inputRef}
                value={filterValue}
                onChange={this.handleChange}
                endpointName={referencedEndpointName}
                className="form-control"
                placeholder={`Search ${referencedEndpointName}`}
                showInactive={true}
                id={this.props.id} />

        )
    }
}

export default connect(null, null, null, { withRef: true })(ReferenceFilter)


// WEBPACK FOOTER //
// ./src/components/filters/referenceFilter.js